var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/ui/components/column_forbidden.tsx";
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import Column from './column';
const messages = defineMessages({
  title: {
    "id": "column_forbidden.title",
    "defaultMessage": "Forbidden"
  },
  body: {
    "id": "column_forbidden.body",
    "defaultMessage": "You do not have permission to access this page."
  }
});
const ColumnForbidden = () => {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(Column, {
    label: intl.formatMessage(messages.title),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "error-column",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 7
    }
  }, intl.formatMessage(messages.body)));
};
export default ColumnForbidden;